import styled from "styled-components"
import BackIcon from "./images/back_icon.svg"
import transportTitle from "./images/travel_title.svg"
import clockContent from "./images/clock_content.svg"
import { useStore } from "../../state/store"

export default function ClockSidebar() {
  const openClockSidebar = useStore(state => state.openClockSidebar)
  const setOpenClockSidebar = useStore(state => state.setOpenClockSidebar)

  return (
    <Sidebar open={openClockSidebar}>
      <SidebarCloseButton onClick={() => setOpenClockSidebar(false)} />
      <SidebarContent>
        <SidebarHeader color="#1D5175">
          <SidebarTitle src={transportTitle} />
          <SidebarSubTitle>
            {"Postmark couldn’t be better connected, however you like to get around."}
          </SidebarSubTitle>
          <SidebarDescription>
            {
              "The whole of central London is easily accessible on foot, by bike or a short taxi ride, or a tube journey from one of the four underground stations within a 15-minute walk. Plus, the arrival of London’s new Elizabeth line (formerly Crossrail) at Farringdon will make it even easier to get across town."
            }
          </SidebarDescription>
        </SidebarHeader>
        <SidbarBody>
          <ClockContent src={clockContent} />
        </SidbarBody>
      </SidebarContent>
    </Sidebar>
  )
}

const Sidebar = styled.div`
  position: fixed;
  top: 0;
  left: ${({ open }) => (open ? "0" : "-30em")};
  z-index: 2;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 30em;
  height: 100%;
  background: #ffffff;
  transition: left 0.5s ease-in-out;
  box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);
`
const SidebarCloseButton = styled.button`
  position: absolute;
  top: 0.5em;
  right: 0.5em;
  z-index: 1;
  width: 2.5em;
  height: 2.5em;
  outline: none;
  border: none;
  cursor: pointer;
  border-radius: 2em;
  transition: all 0.35s cubic-bezier(0.455, 0.03, 0.515, 0.955);
  background-image: url(${BackIcon});
  background-size: 50% 50%;
  background-position: center;
  background-repeat: no-repeat;
  background-color: #00000000;
  &:hover {
    background-color: #efefef;
  }
`
const SidebarContent = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  overflow-y: auto;
`
const SidebarHeader = styled.div`
  padding: 1.5em;
  background-color: ${props => props.color};
`
const SidebarTitle = styled.img`
  width: 100%;
`
const SidebarSubTitle = styled.p`
  font-family: NewParisKingSize-Regular;
  font-weight: 400;
  font-size: 1.3em;
  line-height: 140%;
  color: #ffffff;
  margin: 1em 0;
  padding: 0;
  /* text-align: justify; */
`

const SidebarDescription = styled.p`
  font-family: AzoSans-Regular;
  font-weight: 400;
  font-size: 1em;
  line-height: 120%;
  color: #ffffff;
  margin: 1em 0;
  padding: 0;
  text-align: justify;
`
const SidbarBody = styled.div`
  padding: 1.5em;
  background-color: white;
  user-select: none;
  pointer-events: none;
`
const ClockContent = styled.img`
  width: 100%;
`
